var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column flex-lg-row min-vh-100"},[(_vm.isAuthenticated)?_c('nav-bar'):_vm._e(),_c('div',{staticClass:"flex-grow-1"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }